<template lang="html">
  <div id="services-page">

    <section class="container main-section">
      <div class="row">
        <div class="col-12 col-title">
          <h1 class="title-s1">SERVICIOS</h1>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-info">
          <div class="row">
            <div class="col-lg-4 col-image">
              <div class="placed-backg img" v-bind:style="{ backgroundImage: 'url(public/images/pages/services/image-1.jpg)' }">
                <img src="public/images/shared/empty.png">
              </div>
            </div>

            <div class="col-lg-8 col-text">
              <h5>Fabricación de película a tu medida</h5>

              <p>
                Podemos fabricar cualquier medida de película plástica de acuerdo a las necesidades peculiares de tu negocio.
              </p>
            </div>
          </div>
        </div>

        <div class="col-12 col-info">
          <div class="row">
            <div class="col-lg-4 col-image">
              <div class="placed-backg img" v-bind:style="{ backgroundImage: 'url(public/images/pages/services/image-2.jpg)' }">
                <img src="public/images/shared/empty.png">
              </div>
            </div>

            <div class="col-lg-8 col-text">
              <h5>Corte</h5>

              <p>
                Soluciones de corte a medida de poliburbuja, polipack y cartón. Pregunta a tu asesor sobre las necesidades específicas de corte que requieras.
              </p>
            </div>
          </div>
        </div>

        <div class="col-12 col-info">
          <div class="row">
            <div class="col-lg-4 col-image">
              <div class="placed-backg img" v-bind:style="{ backgroundImage: 'url(public/images/pages/services/image-3.jpg)' }">
                <img src="public/images/shared/empty.png">
              </div>
            </div>

            <div class="col-lg-8 col-text">
              <h5>Entregas a Domicilio</h5>

              <p>
                ZMG, Rutas Foraneas (León, Ags, Morelia, Los Altos de Jal, Zamora – y adicionalmente entrega por paquetería al resto de la República.
              </p>
            </div>
          </div>
        </div>

        <div class="col-12 col-info">
          <div class="row">
            <div class="col-lg-4 col-image">
              <div class="placed-backg img" v-bind:style="{ backgroundImage: 'url(public/images/pages/services/image-4.jpg)' }">
                <img src="public/images/shared/empty.png">
              </div>
            </div>

            <div class="col-lg-8 col-text">
              <h5>Mantenimiento y reparacion de maquinaria<br />(Previa valoración)</h5>

              <p>
                Soluciones integrales en el mantenimiento de maquinaria para la industria del empaque y embalaje. Nuestro equipo altamente calificado no solo se ocupa de las tareas de mantenimiento preventivo y correctivo, sino que también te ayudamos a optimizar el rendimiento de sus maquinarias.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
}
</script>
